/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOperatingCostInvoiceLineItemV1Dto } from '../models/CreateOperatingCostInvoiceLineItemV1Dto';
import type { CreateOperatingCostInvoiceV1Dto } from '../models/CreateOperatingCostInvoiceV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { IdListV1Dto } from '../models/IdListV1Dto';
import type { OperatingCostInvoiceLineItemV1Dto } from '../models/OperatingCostInvoiceLineItemV1Dto';
import type { OperatingCostInvoiceV1Dto } from '../models/OperatingCostInvoiceV1Dto';
import type { PatchOperatingCostInvoiceLineItemV1Dto } from '../models/PatchOperatingCostInvoiceLineItemV1Dto';
import type { PatchOperatingCostInvoiceV1Dto } from '../models/PatchOperatingCostInvoiceV1Dto';
import type { PatchPositionsListV1Dto } from '../models/PatchPositionsListV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OperatingCostInvoicesService {
  /**
   * List all operating cost invoices
   * @returns OperatingCostInvoiceV1Dto a entity list
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1FindAllV1(): CancelablePromise<
    Array<OperatingCostInvoiceV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/operating-cost-invoices',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Create operating cost invoice
   * @param requestBody
   * @returns OperatingCostInvoiceV1Dto create entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1CreateV1(
    requestBody: CreateOperatingCostInvoiceV1Dto,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/operating-cost-invoices',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Delete many operating cost invoices
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/operating-cost-invoices',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Get operating cost invoice by id
   * @param id OperatingCostInvoice ID (UUID v4)
   * @returns OperatingCostInvoiceV1Dto the entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1FindOneV1(
    id: string,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/operating-cost-invoices/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Patch operating cost invoice
   * @param id OperatingCostInvoice ID (UUID v4)
   * @param requestBody
   * @returns OperatingCostInvoiceV1Dto the update entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1UpdatePartialV1(
    id: string,
    requestBody: PatchOperatingCostInvoiceV1Dto,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/operating-cost-invoices/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete operating cost invoice
   * @param id OperatingCostInvoice ID (UUID v4)
   * @returns OperatingCostInvoiceV1Dto the entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1RemoveOneV1(
    id: string,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/operating-cost-invoices/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * List invoices by PointOfSale
   * @param pointOfSaleId PointOfSale ID (UUID v4)
   * @returns OperatingCostInvoiceV1Dto a entity list
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1FindManyByPointOfSaleIdV1(
    pointOfSaleId: string,
  ): CancelablePromise<Array<OperatingCostInvoiceV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/operating-cost-invoices/by-point-of-sale/{pointOfSaleId}',
      path: {
        pointOfSaleId: pointOfSaleId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * List invoices by Contract
   * @param contractId Contract ID (UUID v4)
   * @returns OperatingCostInvoiceV1Dto a entity list
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1FindManyByContractIdV1(
    contractId: string,
  ): CancelablePromise<Array<OperatingCostInvoiceV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/operating-cost-invoices/by-contract/{contractId}',
      path: {
        contractId: contractId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Add Areas to an operating cost invoice (idempotent)
   * @param id OperatingCostInvoice ID (UUID v4)
   * @param requestBody Area IDs to add
   * @returns OperatingCostInvoiceV1Dto create entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1LinkManyAreasV1(
    id: string,
    requestBody: IdListV1Dto,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/operating-cost-invoices/{id}/areas',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Remove multiple Area links from an operating cost invoice
   * @param id OperatingCostInvoice ID (UUID v4)
   * @param requestBody Area IDs to remove
   * @returns OperatingCostInvoiceV1Dto the update entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1UnlinkManyAreasV1(
    id: string,
    requestBody: IdListV1Dto,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/operating-cost-invoices/{id}/areas',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Replace the complete set of Areas linked to an operating cost invoice
   * @param id OperatingCostInvoice ID (UUID v4)
   * @param requestBody Final set of Area IDs (replaces existing links)
   * @returns OperatingCostInvoiceV1Dto the update entity
   * @throws ApiError
   */
  public static operatingCostInvoiceControllerV1ReplaceAreasV1(
    id: string,
    requestBody: IdListV1Dto,
  ): CancelablePromise<OperatingCostInvoiceV1Dto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/operating-cost-invoices/{id}/areas',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * List all positions for an invoice
   * @param invoiceId the parent invoiceid
   * @returns OperatingCostInvoiceLineItemV1Dto a entity list
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1FindAllV1(
    invoiceId: string,
  ): CancelablePromise<Array<OperatingCostInvoiceLineItemV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions',
      path: {
        invoiceId: invoiceId,
      },
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Create a position for an invoice
   * @param invoiceId OperatingCostInvoice ID (UUID v4)
   * @param requestBody
   * @returns OperatingCostInvoiceLineItemV1Dto create entity
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1CreateV1(
    invoiceId: string,
    requestBody: CreateOperatingCostInvoiceLineItemV1Dto,
  ): CancelablePromise<OperatingCostInvoiceLineItemV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions',
      path: {
        invoiceId: invoiceId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Reorder positions of multiple line items for an invoice
   * @param invoiceId OperatingCostInvoice ID (UUID v4)
   * @param requestBody
   * @returns OperatingCostInvoiceLineItemV1Dto the update entity
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1UpdatePartialPositionsV1(
    invoiceId: string,
    requestBody: PatchPositionsListV1Dto,
  ): CancelablePromise<Array<OperatingCostInvoiceLineItemV1Dto>> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions',
      path: {
        invoiceId: invoiceId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete many operating cost invoice lineItems
   * @param invoiceId OperatingCostInvoice ID (UUID v4)
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1RemoveManyV1(
    invoiceId: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions',
      path: {
        invoiceId: invoiceId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * get one positions for an invoice
   * @param invoiceId OperatingCostInvoice ID (UUID v4)
   * @param id
   * @returns OperatingCostInvoiceLineItemV1Dto a entity list
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1FindOneV1(
    invoiceId: string,
    id: string,
  ): CancelablePromise<Array<OperatingCostInvoiceLineItemV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions/{id}',
      path: {
        invoiceId: invoiceId,
        id: id,
      },
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Update a single line item (Teilabrechnungsposition)
   * @param invoiceId OperatingCostInvoice ID (UUID v4)
   * @param id LineItem ID (UUID v4)
   * @param requestBody
   * @returns OperatingCostInvoiceLineItemV1Dto the update entity
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1UpdatePartialV1(
    invoiceId: string,
    id: string,
    requestBody: PatchOperatingCostInvoiceLineItemV1Dto,
  ): CancelablePromise<OperatingCostInvoiceLineItemV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions/{id}',
      path: {
        invoiceId: invoiceId,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete a line item (soft delete)
   * @param invoiceId OperatingCostInvoice ID (UUID v4)
   * @param id LineItem ID (UUID v4)
   * @returns OperatingCostInvoiceLineItemV1Dto the entity
   * @throws ApiError
   */
  public static operatingCostInvoiceLineItemControllerV1RemoveOneV1(
    invoiceId: string,
    id: string,
  ): CancelablePromise<OperatingCostInvoiceLineItemV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/operating-cost-invoices/{invoiceId}/positions/{id}',
      path: {
        invoiceId: invoiceId,
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
